import { render } from "./DesktopHome.vue?vue&type=template&id=f74c4e3e&scoped=true"
import script from "./DesktopHome.vue?vue&type=script&lang=js"
export * from "./DesktopHome.vue?vue&type=script&lang=js"

import "./DesktopHome.vue?vue&type=style&index=0&id=f74c4e3e&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f74c4e3e"]])

export default __exports__